/* @jsxImportSource @emotion/react */
/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'
import { css, keyframes } from '@emotion/react'

import { Button } from '../../../components/Button/Button'

// Minimal shape this component cares about — both the hero scenarios and
// the AI-search scenarios satisfy this, so the component is shared.
type ScenarioLike = { id: string; buttonLabel: string }

type Props<S extends ScenarioLike> = {
  scenarios: S[]
  activeIdx: number
  playId: number
  durationMs: number
  onSelect: (idx: number) => void
}

const fillGrowA = keyframes`from { transform: scaleX(0) } to { transform: scaleX(1) }`
const fillGrowB = keyframes`0% { transform: scaleX(0) } 100% { transform: scaleX(1) }`

const fillStyles = (durationMs: number, playId: number) => css`
  background: var(--moon-dust);

  & > * {
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    background: var(--moon-dust-darker);
    transform-origin: left center;
    transform: scaleX(0);
    will-change: transform;
    animation: ${playId % 2 ? fillGrowA : fillGrowB} ${durationMs}ms linear
      forwards;
    pointer-events: none;
  }
`

export const ScenarioButtons = <S extends ScenarioLike>({
  scenarios,
  activeIdx,
  playId,
  durationMs,
  onSelect,
}: Props<S>) => (
  <div
    className="flexbox flexbox-centered flexbox-gap-12 flexbox-wrap"
    style={{ marginBottom: 24 }}
  >
    {scenarios.map((s, i) => {
      const isActive = i === activeIdx

      return (
        <Button
          key={s.id}
          variant="ghost"
          onClick={() => !isActive && onSelect(i)}
          aria-label={s.buttonLabel}
          className="position-relative overflow-hidden"
          css={
            isActive
              ? fillStyles(durationMs, playId)
              : css`background: var(--moon-dust)`
          }
        >
          <span>{s.buttonLabel}</span>
        </Button>
      )
    })}
  </div>
)
